import { useEffect, useState } from "react";

import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
} from "@mui/material";
import { StatefulControlledTextField } from "components/Core/StatefulControlledTextField";
import { useFormStatus } from "mui-toolkit/useFormStatus";

export const ACCOUNT_TYPES = ["rjo", "hp"];
// ---

export const ClientAccountNumberDialog = ({ onChange, onClose, data }) => {
  const { actions: formStatusActions } = useFormStatus();

  const [state, setState] = useState({});

  const onSubmit = () => {
    onChange?.(state);
    onClose?.();
  };

  useEffect(() => {
    setState({
      container: "rjo",
      object: "account_number",
      value: "",
      is_active: true,
    });
  }, [data]);

  const handleChangeState = async (event, value) => {
    value = value ?? event?.target?.value;

    if (state[event.target.name] !== value) {
      formStatusActions.setIsFormDirty(true, false);

      setState((prevState) => {
        prevState[event.target.name] = value;
        return prevState;
      });
    }
  };

  const formatProducerName = () => {
    return state?.business_name || state?.first_name
      ? state?.business_name
        ? state?.business_name
        : state?.first_name + " " + state?.last_name
      : "";
  };

  // ---

  return (
    <>
      <DialogTitle>{formatProducerName(state)}</DialogTitle>

      <DialogContent>
        <Box sx={{ width: "100%" }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <FormControl fullWidth>
                <InputLabel id="container-select-label">Account Type</InputLabel>
                <Select
                  labelId="container-select-label"
                  value={state?.container || ""}
                  name="container"
                  label="Account Type"
                  onChange={(event) => handleChangeState(event, event.target.value)}
                >
                  {ACCOUNT_TYPES.map((value) => (
                    <MenuItem key={value} value={value}>
                      {value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={12}>
              <FormControl fullWidth={true}>
                <StatefulControlledTextField
                  label="Account Number"
                  name="value"
                  isRequired={true}
                  defaultValue={state?.value || ""}
                  onChange={handleChangeState}
                  InputLabelProps={{ shrink: true }}
                />
              </FormControl>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>

      <DialogActions>
        <Stack direction="row-reverse" spacing={1} useFlexGap flexWrap="wrap" justifyContent="flex-end">
          <Button variant="contained" onClick={onSubmit}>
            OK
          </Button>
          <Button variant="contained" color="secondary" autoFocus onClick={onClose}>
            Cancel
          </Button>
        </Stack>
      </DialogActions>
    </>
  );
};
